// Models
import { homeContentModels } from './home'
import { galleryContentModels } from './gallery'
import { tukContentModels } from './tuk'
import { certificationContentModels } from './certification'
import { aboutUsContentModels } from './about-us'
import { contactUsModels } from './contact-us'

const contentManagementModels = {
  ...homeContentModels,
  ...galleryContentModels,
  ...tukContentModels,
  ...certificationContentModels,
  ...aboutUsContentModels,
  ...contactUsModels,
}

export { contentManagementModels }
